import { FC, useMemo } from "react";

import { EditBlock, IEditBlockItem } from "shared/components";
import { copy } from "shared/assets";
import { Guests, Megaphone, Plane, Time, UserMultiple, Venue } from "shared/assets/icons";
import { useEventRoute } from "Bands/utils";
import { BAND_PATHS } from "Bands/router";
import { useEventContext } from "Bands/contexts";

const helpBlockCopy = copy.event.helpBlock;

export const EventHelpBlock: FC = () => {
  const { userPermissions } = useEventContext();
  const { getPath } = useEventRoute();

  const items = useMemo(() => {
    const eventItems = [] as IEditBlockItem[];

    eventItems.push({
      icon: Venue,
      label: helpBlockCopy.venue,
      to: getPath(BAND_PATHS.CREATE_VENUE_BLOCK),
    });

    eventItems.push({
      icon: UserMultiple,
      label: helpBlockCopy.people,
      to: getPath(BAND_PATHS.CREATE_PEOPLE_BLOCK),
    });

    eventItems.push({
      icon: Guests,
      label: helpBlockCopy.guestlist,
      to: getPath(BAND_PATHS.CREATE_GUESTLIST_BLOCK),
    });

    eventItems.push({
      icon: Time,
      label: helpBlockCopy.schedule,
      to: getPath(BAND_PATHS.CREATE_SCHEDULE_BLOCK),
    });

    eventItems.push({
      icon: Plane,
      label: helpBlockCopy.travel,
      to: getPath(BAND_PATHS.CREATE_TRAVEL_BLOCK),
    });

    return eventItems;
  }, [getPath]);

  const hasAllPermissions = useMemo(
    () =>
      userPermissions.CREATE_VENUE_BLOCK &&
      userPermissions.CREATE_PEOPLE_BLOCK &&
      userPermissions.CREATE_GUESTLIST_BLOCK &&
      userPermissions.CREATE_SCHEDULE_BLOCK,
    [userPermissions]
  );

  if (!items.length) return null;

  // only show block if user has all needed permissions
  if (!hasAllPermissions) return null;

  return (
    <EditBlock
      id="event-page-help-block"
      cardTitle={helpBlockCopy.title}
      cardIcon={Megaphone}
      items={items}
    />
  );
};
